import type {InviteApiModel} from '../../../../api/invite';
import type {MembershipApiModel} from '../../../../api/membership';
import type {Invite} from '../types';

import {getEntityTypeById} from '../../../../utils/entity/getEntityType';
import {AppError} from '../../../../utils/errors/app';
import {ResendProposedMembershipStrategy} from './ResendProposedMembershipStrategy';
import {ResendRegularInviteStrategy} from './ResendRegularInviteStrategy';

export class ResendInviteStrategyFactory {
  static createStrategy(invite: Invite) {
    const entityType = getEntityTypeById(invite._id);

    switch (entityType) {
      case 'invite':
        return new ResendRegularInviteStrategy(invite as InviteApiModel);
      case 'membership':
        return new ResendProposedMembershipStrategy(
          invite as MembershipApiModel,
        );
      default:
        throw new AppError(`Unknown invite target entity type: ${entityType}`);
    }
  }
}
